import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { ApiServicesService } from 'src/app/services/apiServices/api-services.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { LocalStorageProvider } from 'src/app/services/storage/storage.service';
import { MatSelect } from '@angular/material/select';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { UntypedFormBuilder } from '@angular/forms';
import { ValidationsService } from 'src/app/services/validators/validator';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { switchMap, tap, catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    yearLabel: 'YYYY',
    dateA11yLabel: 'YYYY',
    yearA11yLabel: 'YYYY',
  },
};



@Component({
  selector: 'app-add-machine',
  templateUrl: './add-machine.component.html',
  styleUrls: ['./add-machine.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  // providers: [DatePipe,
  //   {
  //     provide: DateAdapter,
  //     useClass: MomentDateAdapter,
  //     deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
  //   },

  //   { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  // ],
})
export class AddMachineComponent implements OnInit {
  maxFileSize = 10 * 1024 * 1024; // 5 MB
  maxFiles = 5;
  uploadedFiles: File[] = [];
  filePreviews: string[] = []; // Array to hold image previews
  pdfPreviews: string[] = [];   // Array to hold PDF previews
  errorMessages: string[] = [];
  machineForm: any
  profileDetails: any;
  subcategory: any;
  subCategory: any = [];
  myProfile: boolean = true;
  panIndia: boolean = false;
  progress: number = 39;
  isToggled1: boolean = false;
  isToggled2: boolean = false;
  isToggled3: boolean = false;
  addForm: FormGroup;
  productId: any;
  update: boolean = false;
  add: boolean = true;
  data: any;
  duplicate: any;
  media: { url: string, type: string }[] = [];
  dropdownOptions: { [key: string]: string[] } = {};
  selectedValues: any;
  minDate: string;

  constructor(private service: ApiServicesService, private storageService: LocalStorageProvider, private commonService: CommonService, private fb: FormBuilder, public validators: ValidationsService, private route: ActivatedRoute, private router: Router, private toastr: ToastrService, private el: ElementRef, private cdr: ChangeDetectorRef) {
  }
  ngOnInit(): void {
    // this.getBrand();
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0];
    this.fetchCategoryByIndustry('6d107209-573e-4a13-8c39-9eb299d16246');
    this.getDropdowns();
    this.getState();
    this.getCountriesList();
    this.isToggled1 = true;
    this.industry = [
      { id: '6d107209-573e-4a13-8c39-9eb299d16246', industry_name: 'Machine' },
    ];
    this.addForm = this.fb.group({
      specifications: [{}],
      highlights: [this.service.getValueOrDefault("null", null)],
      media: ['', [Validators.required]],
      is_featured: [false, []],
      is_sold: [false, []],
      industry_id: ['6d107209-573e-4a13-8c39-9eb299d16246', [Validators.required]],
      category1_id: ['', [Validators.required]],
      category2_id: ['', [Validators.required]],
      // category2_name: [this.service.getValueOrDefault("null", null)],
      category3_id: ['', [Validators.required]],
      sub_title: ['', [Validators.required]],
      category3_name: [this.service.getValueOrDefault("null", null)],
      description: ['', [Validators.required]],
      brand_id: ['', [Validators.required]],
      // location: [this.service.getValueOrDefault("null", null)],
      model_number: [this.service.getValueOrDefault("null", null)],
      manufacturing_year: ['', [Validators.required]],
      price_type: ['', [Validators.required]],
      gst_inclusive: ['no', []],
      price: ['', [Validators.required, Validators.maxLength(10)]],
      // punit: ['', Validators.required],
      automation_level: [this.service.getValueOrDefault("null", null)],
      product_condition: ['', [Validators.required]],
      number_units_available: ['', [Validators.required]],
      country_origin: [this.service.getValueOrDefault("null", null)],
      warranty_available: ['no', []],
      warranty_period: [this.service.getValueOrDefault(0, 0), []],
      coverage_details: [this.service.getValueOrDefault("null", null)],
      bulk_order_provision: ['no', []],
      under_hypothecation: ['no', []],
      after_sale_service: [this.service.getValueOrDefault("null", null)],
      offer_applicable: ['no', []],
      offer_details: [this.service.getValueOrDefault("null", null)],
      AMC: [this.service.getValueOrDefault(0, 0)],
      SLA: [this.service.getValueOrDefault(0, 0)],
      city: ['', []],
      state: ['', [Validators.required]],
      offer_validity: ['', []],
      brand_name: [this.service.getValueOrDefault("null", null)],
    }
    );
    this.route.queryParams.subscribe(params => {
      this.productId = params['productId'];
      if (params['duplicate'] && this.productId) {
        this.duplicate = params['duplicate'];
        this.getData(this.duplicate);
      } else {
        if (this.productId) {
          this.update = true;
          this.add = false;
          this.getData();
        } else {
          this.update = false;
          this.add = true;
        }
      }
    });
  }
  maxDate = moment().endOf('year').toDate();
  chosenYearHandler(normalizedYear: moment.Moment, datepicker: any): void {
    const formattedYear = normalizedYear.format('YYYY'); // Format year as 'YYYY'
    this.addForm.get('manufacturing_year')?.setValue(formattedYear); // Update form control
    datepicker.close();
  }


  getData(duplicate = 'false') {
    this.service.get({ productId: this.productId }, `${API_ROUTES.Account.getProductDetailById}`).pipe().subscribe((res: { data: any; }) => {
      this.data = res.data;
      for (const key in this.data) {
        if (this.data.hasOwnProperty(key) && key !== 'Brand' && key !== 'specifications') {
          if (this.addForm.contains(key)) {
            this.addForm.get(key)?.setValue(this.data[key]);
          }
        }
      }
      // console.log(this.data, 'edit data');
      if (this.data.Category1) {
        this.fetchCategoryBycat1(this.data.Category1.id).pipe(
          switchMap(() => this.fetchCategoryBycat2(this.data.Category2.id)),
          switchMap(() => this.onIndustryBycat3(this.data.Category3.id, this.data.specifications)),
          switchMap(() => this.fetchBrands(this.data.Category1.id))
        ).subscribe(() => {
          // console.log('All data fetched');
          if (this.brandss && this.brandss.length > 0) {
            this.onBrandchange(this.data.brand_id);
          } else {
            // console.error('Brand data is not loaded yet.');
          }
          if (this.data.Category3.title === 'Other') {
            this.subcatgname = true;
          }
        });
      }
      if (this.data.offer_applicable == 'yes') {
        this.offer = true;
        this.addForm.get('offer_details')?.setValidators([Validators.required]);
        this.addForm.get('offer_details')?.updateValueAndValidity();
      } else {
        this.offer = false;
        this.addForm.get('offer_details')?.removeValidators([Validators.required]);
        this.addForm.get('offer_details')?.updateValueAndValidity();
      }
      if (this.data.warranty_available == 'yes') {
        this.warranty = true;
        this.addForm.get('warranty_period')?.setValidators([Validators.required]);
        this.addForm.get('warranty_period')?.updateValueAndValidity();
      } else {
        this.addForm.get('warranty_period')?.removeValidators([Validators.required]);
        this.addForm.get('warranty_period')?.updateValueAndValidity();
      }
      if (this.data.product_condition == 'Used') {
        this.hypo = true;
      }
      this.getCityData(this.data.state);
      if (this.data.Media) {
        this.addForm.patchValue({ media: this.data.Media });
      }
      if (duplicate == 'true') {
        this.update = false;
        this.add = false;
        this.duplicate = true;
        // this.duplicateEntry(this.addForm.value);
      }
    });
  }
  hypo: boolean = false;
  onCondition(condition: any) {
    if (condition == 'Used') {
      this.hypo = true;
      // this.addForm.get('under_hypothecation')?.setValue('yes');
    } else {
      this.hypo = false;
    }

  }
  stateData: any;
  cityData: any;
  filteredStateData: any;
  getState() {
    this.service.get({}, API_ROUTES.Account.stateCity).subscribe(
      (res) => {
        if (res.success && res.data) {
          this.stateData = res.data;
          this.filteredStateData = [...this.stateData]; // Initialize with full list  // Store the state data
        }
      },
      (error) => {
        console.error('API call failed:', error);
      }
    );
  }

  countriesList: any;
  filteredCountriesData: any;
  getCountriesList() {
    this.service.get({}, API_ROUTES.Account.countriesList).subscribe(
      (res) => {
        if (res.success && res.data) {
          this.countriesList = res.data.rows;
          this.filteredCountriesData = [...this.countriesList]; // Initialize with full list  // Store the state data
        }
      },
      (error) => {
        console.error('API call failed:', error);
      }
    );
  }

  filteredCountries(searchValue: string) {
    const search = searchValue.toLowerCase();
    this.filteredCountriesData = this.countriesList.filter((country: any) =>
      country.name.toLowerCase().includes(search)
    );
  }

  // Triggered when a state is selected, fetch cities based on selected state
  onStateChange(event: any) {
    const stateId = event.value;

    const cityControl = this.addForm.get('city');
    cityControl?.setValue(''); // Optional: clear value if needed
    if (stateId === 37) {
      cityControl?.clearValidators();
      
    } else {
      cityControl?.setValidators(Validators.required);
    }

    cityControl?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    if (stateId) {
      this.getCityData(stateId);  // Fetch cities for the selected state
      this.clearSearch();
    }
  }
  onCityChange(event: any) {
    this.clearSearch();
  }
  filteredcityData: any;

  // Fetch city data based on the selected state
  getCityData(stateId: string) {
    this.service.get({ stateId }, API_ROUTES.Account.stateCity).subscribe(
      (res) => {
        if (res.success && res.data) {
          this.cityData = res.data;
          this.filteredcityData = [...this.cityData];
          // console.log(this.cityData.length, 'lrn')
          this.addForm.get('city')?.setValidators(this.cityData?.length > 0 ? [Validators.required] : []);
          this.addForm.get('city')?.updateValueAndValidity();
          // Store the city data based on state
        } else {
          this.cityData = [];  // Clear city data if no cities found
          this.addForm.get('city')?.setValue(null);
          this.addForm.get('city')?.removeValidators([Validators.required]);
          this.addForm.get('city')?.updateValueAndValidity();
        }
      },
      (error) => {
        console.error('API call failed for cities:', error);
      }
    );
  }
  filteredBrandData: any;
  filterBrand(searchValue: string) {
    const search = searchValue.toLowerCase();
    // console.log(search, 'sear')
    this.filteredBrandData = this.brandss.filter((brand: { brand_name: string; }) =>
      brand.brand_name.toLowerCase().includes(search)
    );
  }
  searchValue: string = '';
  filterStates(searchValue: string) {
    const search = searchValue.toLowerCase();
    this.filteredStateData = this.stateData.filter((state: { name: string; }) =>
      state.name.toLowerCase().includes(search)
    );
  }
  filterCity(searchValue: string) {
    const search = searchValue.toLowerCase();
    this.filteredcityData = this.cityData.filter((city: { city: string; }) =>
      city.city.toLowerCase().includes(search)
    );
  }
  clearSearch(searchInput?: HTMLInputElement) {
    if (searchInput) {
      searchInput.value = ''; // Clear the input field
    }
    this.filteredStateData = [...this.stateData]; // Reset to full list
    if (this.cityData) {
      this.filteredcityData = [...this.cityData];
    }
    if (this.brandss) {

      this.filteredBrandData = [...this.brandss];
    }
  }
  newId: any;
  duplicateEntry(post: any) {
    for (let field in post) {
      if (post[field] === '') {
        post[field] = 'null'; // Send 'null' as string for text fields
      }
    }
    const filteredValues = Object.keys(post).reduce((result: any, key) => {
      const value = post[key];
      if (
        value !== null &&
        value !== 'null' &&
        (Array.isArray(value) || value !== '') // Allow arrays to pass through
      ) {
        result[key] = value;
      }
      return result;
    }, {});
    if (this.addForm.valid) {
      delete filteredValues.is_sold;
      // console.log('Final duplicate data to submit:', post);
      // this.service.post(filteredValues, `${API_ROUTES.Account.addProduct}`, {}).pipe().subscribe((res: { success: boolean; message: string; result: any | undefined; }) => {
      //   if (res.success == true) {
      //     this.toastr.success('Form duplicated successfully');
      //     this.productId = res.result.product.id;
      //     // console.log('Form duplicated successfully');
      //     this.update = true;
      //     this.add = false;
      //     this.newId = res.result.product.id;
      //   } else {
      //     this.toastr.error(res.message);
      //     this.service.scrollToToast();
      //     console.log(res.message);
      //   }
      // },
      //   (error: { message: string | undefined; }) => {
      //     this.toastr.error(error.message);
      //     this.service.scrollToToast();
      //     console.log(error.message);
      //   });
    } else {
      this.scrollToFirstInvalidControl();
      return;
    }
  }

  onFileChangedemo(event: any) {
    // this.errorMessages = [];
    this.errorMessages = [];
    const files: FileList = event.target.files;
    if (files) {
      // Get the current media array
      const mediaControl = this.addForm.get('media') as FormControl;
      const currentMedia = mediaControl.value || [];

      // Check if the current count plus new files exceeds the limit
      if (currentMedia.length + files.length > 5) {
        // console.log('eeeee');
        this.errorMessages.push('You can upload a maximum of 5 files.');
        this.toastr.error('You can upload a maximum of 5 files.');
        return;
      }
      if (currentMedia.length === 0) {
        const firstFile = files[0];
        if (!this.isImage(firstFile)) {
          this.toastr.error('The first file must be an image.');
          this.errorMessages.push('The first file must be an image.');
          return;
        }
      }
      // const files: FileList = event.target.files;
      // if (files) {
      for (let file of Array.from(files)) {
        if (this.validateFile(file)) {
          this.uploadFiledemo(file).then((url) => {
            if (url) {
              const mediaControl = this.addForm.get('media') as FormControl;
              const fileObject = { url, media_type: file.type };
              const currentMedia = mediaControl.value || [];
              mediaControl.patchValue([...currentMedia, fileObject]);
            }
          }).catch(err => {
            this.toastr.error(err);
            console.error('Error uploading file:', err);
          });
        }
      }
    }
  }
  isImage(file: File): boolean {
    const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/jfif'];
    return allowedImageTypes.includes(file.type);
  }
  // Validates file size and type
  validateFile(file: File): boolean {
    if (file.size > this.maxFileSize) {
      this.toastr.error(`${file.name} exceeds the maximum file size of 10 MB.`);
      this.errorMessages.push(`${file.name} exceeds the maximum file size of 10 MB.`);
      return false;
    }
    const allowedTypes = ['image/jpeg', 'image/png', 'video/mp4', 'image/gif', 'image/webp', 'image/jfif'];
    if (!allowedTypes.includes(file.type)) {
      this.toastr.error(`${file.name} is not a valid file type.`);
      this.errorMessages.push(`${file.name} is not a valid file type.`);
      return false;
    }
    return true;
  }

  uploadFiledemo(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('files', file);
    return this.service.postWithFetch(formData, API_ROUTES.Account.submitImage, {
      // param1: 'value1', 
    });
  }

  // Submit form data
  onSubmit(post: any) {
    this.addForm.get('category3_name')?.setValidators(this.subcatgname ? [Validators.required] : []);
    this.addForm.get('brand_name')?.setValidators(this.brandname ? [Validators.required] : []);
    this.addForm.get('category3_name')?.updateValueAndValidity();
    this.addForm.get('brand_name')?.updateValueAndValidity();
    this.submitted = true;
    if (post.AMC === '') {
      post.AMC = null;  // Set integer 0 for AMC
    }
    if (post.SLA === '') {
      post.SLA = null;  // Set integer 0 for SLA
    }
    if (post.warranty_period === '') {
      post.warranty_period = null;  // Set integer 0 for SLA
    }
    for (let field in post) {
      if (post[field] === '') {
        post[field] = null; // Send 'null' as string for text fields
      }
    }
    // console.log(post,'post');
    const filteredValues = Object.keys(post).reduce((result: any, key) => {
      const value = post[key];
      if (
        value !== null &&
        value !== 'null' &&
        (Array.isArray(value) || value !== '') // Allow arrays to pass through
      ) {
        result[key] = value;
      }
      return result;
    }, {});

    if (this.duplicate == 'true' || this.duplicate == true) {
      // console.log('dup add');
      delete post.is_sold;
      if (this.addForm.valid) {
        this.service.post(post, `${API_ROUTES.Account.addProduct}`, {}).pipe().subscribe((res: { success_code: number; result: { error: string | undefined; }; message: any; }) => {
          if (res.success_code == 200) {
            this.toastr.success('Duplicate Form Added');
            this.addForm.reset();
            this.router.navigate(['/main/profile/my-listings'], {
              queryParams: { selectedCategory: 'Machine' }
            });
            window.scrollTo(0, 0);
          } else {
            this.toastr.error(res.result.error);
            this.service.scrollToToast();
            // console.log(res.message);
          }
        },
          (error: { result: { error: string | undefined; }; message: any; }) => {
            this.toastr.error(error.result.error);
            this.addForm.markAllAsTouched();
            this.scrollToFirstInvalidControl();
            return;
            // this.service.scrollToToast();
            // console.log(error.message);
          })
      } else {
        this.addForm.markAllAsTouched();
        this.scrollToFirstInvalidControl();
        return;
      }
    } else {
      if (this.productId) {
        if (this.cityData?.length == 0) {
          post.city = null;
        }
        console.log(post)
        if (this.addForm.valid) {
          this.update = true;
          this.add = false;
          this.service.put(post, { product_id: this.productId }, `${API_ROUTES.Account.updateProduct}`).pipe().subscribe((res: { success_code: number; result: { error: string | undefined; }; message: any; }) => {
            if (res.success_code == 200) {
              this.toastr.success('Form Updated');
              this.addForm.reset();
              this.router.navigate(['/main/profile/my-listings'], {
                queryParams: { selectedCategory: 'Machine' }
              });
              // this.router.navigate(['/main/profile/my-listings']);
              window.scrollTo(0, 0);
            } else {
              this.toastr.error(res.result.error);
              this.service.scrollToToast();
              console.log(res.message);
            }
          },
            (error: { result: { error: string | undefined; }; error: any; }) => {
              this.toastr.error(error.result.error);
              this.service.scrollToToast();
              // console.log(error.message);
            })
        } else {
          this.addForm.markAllAsTouched();
          this.scrollToFirstInvalidControl();
          return;
        }
      } else {
        // Object.keys(this.addForm.controls).forEach(key => {
        //   const control = this.addForm.get(key);
        //   console.log(`${key}:`, control?.invalid ? 'Invalid' : 'Valid', control?.errors);
        // });
        if (this.cityData?.length == 0) {
          post.city = null;
        }
        if (this.addForm.valid) {
          // console.log(post)
          this.service.post(post, `${API_ROUTES.Account.addProduct}`, {}).pipe().subscribe((res: { success: boolean; message: string | undefined; }) => {
            if (res.success == true) {
              this.toastr.success('Form submitted successfully');
              this.addForm.reset();
              this.uploadedFiles = [];
              this.router.navigate(['/main/profile/my-listings'], {
                queryParams: { selectedCategory: 'Machine' }
              });
              // this.router.navigate(['/main/profile/my-listings']);
              window.scrollTo(0, 0);
            } else {
              this.toastr.error(res.message);
              this.service.scrollToToast();
              // console.log(res.message);
            }
          },
            (error: { result: { error: string | undefined; }; }) => {
              this.toastr.error(error.result.error);
              this.service.scrollToToast();
              // console.log(error);
            });
        } else {
          this.addForm.markAllAsTouched(); // Ensure all controls are marked
          this.scrollToFirstInvalidControl();
          return;
        }
      }
    }
  }
  scrollToFirstInvalidControl(): void {
    // Ensure all controls are marked as touched
    this.addForm.markAllAsTouched();

    // Query for the first invalid control
    const firstInvalidControl = this.el.nativeElement.querySelector(
      '[formControlName].ng-invalid' // Adjust selector if necessary
    );

    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalidControl.focus?.(); // Optionally set focus
    } else {
      console.warn('No invalid control found!');
    }
  }


  isImageType(mediaType: string): boolean {
    return mediaType.startsWith('image/');
  }
  removeFile(index: number) {
    const mediaControl = this.addForm.get('media') as FormControl;

    if (mediaControl && mediaControl.value && mediaControl.value.length > index) {
      const currentMedia = [...mediaControl.value]; // Create a shallow copy
      // console.log(currentMedia, 'curMed');

      // Check if the file to be removed is the first file
      if (index == 0) {
        // console.log(index, 'index');
        // Find the next image in the list
        const nextImageIndex = currentMedia.findIndex((file: any, i: number) =>
          i !== index && this.isImageType(file.media_type)
        );
        // console.log(nextImageIndex, 'nextImageIndex');

        // If no image exists after the first, prevent removal
        if (nextImageIndex === -1) {
          this.errorMessages.push('The first file must be an image.');
          return;
        }

        // Swap the first image with the next image
        const temp = currentMedia[nextImageIndex];
        currentMedia[nextImageIndex] = currentMedia[0];
        currentMedia[0] = temp;

        // Now remove the original first image (which has been swapped to the nextImageIndex)
        currentMedia.splice(nextImageIndex, 1);
      } else {
        // For non-first files, simply remove the file at the specified index
        currentMedia.splice(index, 1);
      }

      // Update the 'media' FormControl with the new file list
      mediaControl.patchValue(currentMedia);
    }
  }



  // Drag-and-drop handlers
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.errorMessages = [];
    const files = event.dataTransfer?.files;
    if (files) {
      for (let file of Array.from(files)) {
        if (this.validateFile(file)) {
          this.uploadFiledemo(file).then((url) => {
            if (url) {
              const currentMedia = this.addForm.get('media')?.value || [];
              this.addForm.patchValue({ media: [...currentMedia, { url, media_type: file.type }] });
            }
          }).catch(err => {
            console.error('Error uploading file:', err);
          });
        }
      }
    }
  }
  industry: any;
  getIndustry() {
    this.service.get({}, `${API_ROUTES.Account.getIndustry}`).pipe().subscribe((res: { result: any; }) => {
      this.industry = res.result;
      // console.log(this.industry, 'industry');
    })
  }

  category1: any;
  fetchCategoryByIndustry(indusid: string) {
    this.service.post({ industry_id: indusid }, `${API_ROUTES.Account.getIndustriesByCategorys}`, { industry_id: indusid }).pipe().subscribe((res: { result: { rows: any; }; }) => {
      this.category1 = res.result.rows;
    }, (err: any) => {
      this.category1 = [];
    });
  }

  onIndustryChange(selectedIndustryId: string): void {
    this.addForm.get('category2_id')?.setValue('');
    this.addForm.get('brand_id')?.setValue('');
    this.dynamicFields = [];
    this.addForm.get('specifications')?.setValue({});
    // this.addForm.get('country_origin')?.setValue('');
    this.dropdownOptions = {};
    if (selectedIndustryId) {
      this.fetchCategoryBycat1(selectedIndustryId).subscribe(() => {
        this.category3 = []; // Clear sub-categories when a new industry is selected
      });
      this.fetchBrands(selectedIndustryId).subscribe();
    }
  }
  brandss: any;
  fetchBrands(indusid: string): Observable<any> {
    return this.service.get({ category1_id: indusid }, `${API_ROUTES.Account.getBrand}`).pipe(
      tap((res: { result: any[] }) => {
        this.brandss = res.result || []; // Assign result to brandss
        this.filteredBrandData = [...this.brandss];
        // console.log('Brands loaded:', this.brandss); // Verify brandss is updated
      }),
      catchError((err) => {
        // console.error('Error fetching brands:', err);
        this.brandss = []; // Ensure brandss is reset to an empty array on error
        return of(null);
      })
    );
  }

  category2: any;
  fetchCategoryBycat1(indusid: string): Observable<any> {
    return this.service.post({ category1_id: indusid }, `${API_ROUTES.Account.getCatByCategory1}`, {}).pipe(
      tap((res: { result: { rows: any[] } }) => {
        this.category2 = res.result.rows;
        // this.addForm.get('category2_id')?.setValue('');
      }),
      catchError((err) => {
        this.category2 = [];
        return of(null); // Return a null Observable in case of error
      })
    );
  }

  onIndustryBycat2(selectedIndustryId: any) {
    this.addForm.get('category3_id')?.setValue('');
    this.dynamicFields = [];
    this.addForm.get('specifications')?.setValue({});
    this.dropdownOptions = {};
    // this.addForm.get('country_origin')?.setValue('');
    if (selectedIndustryId) {
      // console.log(selectedIndustryId,'cat2id')
      this.fetchCategoryBycat2(selectedIndustryId).subscribe();;
    }
  }
  category3: any;
  // catgname: boolean = false;
  fetchCategoryBycat2(indusid: string): Observable<any> {
    return this.service.post({ category2_id: indusid }, `${API_ROUTES.Account.getCatByCategory2}`, {}).pipe(
      tap((res: { result: { rows: any[] } }) => {
        // console.log('Category 3 Response:', res);
        this.category3 = res.result.rows;
      }),
      catchError((err) => {
        this.category3 = [];
        return of(null); // Return a null Observable in case of error
      })
    );
  }
  onSubcategory3(selectedIndustryId: any) {
    if (selectedIndustryId) {
      this.dynamicFields = [];
      this.addForm.get('specifications')?.setValue({});
      this.dropdownOptions = {};
      this.addForm.get('highlights')?.setValue(null);
      // console.log(selectedIndustryId,'cat2id')
      this.onIndustryBycat3(selectedIndustryId).subscribe();
    }
  }
  onOfferValidityChange(event: any): void {
    const selectedDate = event.target.value; // Get the selected date in 'yyyy-MM-dd'
    const today = new Date().toISOString().split('T')[0]; // Today's date in 'yyyy-MM-dd'

    if (selectedDate < today) {
      alert('Invalid date: Please select a date from today onwards.');
      this.addForm.get('offer_validity')?.setValue(''); // Reset invalid date
    } else {
      // Convert 'yyyy-MM-dd' to 'dd-MM-yyyy' for the form control
      const [year, month, day] = selectedDate.split('-');
      const formattedDate = `${day}-${month}-${year}`;

      // Update the form control with the formatted date
      this.addForm.get('offer_validity')?.setValue(formattedDate);

      console.log('Formatted Date:', formattedDate); // Debug log
    }
  }

  // Get the date in 'yyyy-MM-dd' format for the input field
  getInputDateValue(): string {
    const formValue = this.addForm.get('offer_validity')?.value;

    if (formValue) {
      // Convert 'dd-MM-yyyy' back to 'yyyy-MM-dd' for the input field
      const [day, month, year] = formValue.split('-');
      return `${year}-${month}-${day}`;
    }

    return ''; // Default value
  }
  brandname: boolean = false;
  subcatgname: boolean = false;
  specification: any;
  dynamicFields: string[] = [];
  selectedBrandTitle: string = '';
  country_name: any;
  isCountryReadonly: boolean = true;
  onBrandselect(id: any) {
    this.addForm.get('country_origin')?.setValue('');
    this.onBrandchange(id);
  }
  onBrandchange(id: any) {
    if (!this.brandss || this.brandss.length === 0) {
      console.error('Brand data is not available yet.');
      return;
    }

    const selectedCategory = this.brandss.find((cat: { id: any }) => cat.id === id);
    if (selectedCategory) {
      this.selectedBrandTitle = selectedCategory.brand_name;
      this.brandname = this.selectedBrandTitle === 'Other';

    } else {
      this.brandname = false;
      console.error(`Brand with id ${id} not found.`);
    }
    // if (this.brandname == false) {
    this.service.post({ id: id }, `${API_ROUTES.Account.getCountry}`, {})
      .pipe()
      .subscribe(
        (res: { result: any[] }) => {
          if (res.result && res.result.length > 0 && res.result[0]?.country_name != null) {
            // Access the first item's country_name
            this.country_name = res.result[0]?.country_name;
            this.isCountryReadonly = true;
            this.addForm.get('country_origin')?.setValue(this.country_name);
          } else {
            // this.country_name = '';
            this.isCountryReadonly = false;
            this.addForm.get('country_origin')?.setValidators([Validators.required]);
            this.addForm.get('country_origin')?.updateValueAndValidity();

          }
          // console.log(this.country_name, 'country_name');
        },
        (err: any) => {
          console.error('API Error:', err);
          this.country_name = '';
          this.addForm.get('country_origin')?.setValue(this.country_name);
        }
      );
    // }

    this.clearSearch();
  }
  toolspecify: boolean = false;
  selectedCategoryTitle: string = '';
  onIndustryBycat3(id: any, selectedData: any = {}) {
    return of(null).pipe(
      tap(() => {
        // console.log('cat3', this.category3)
        const selectedCategory = this.category3.find((cat: { id: any }) => cat.id == id);
        if (selectedCategory) {
          this.selectedCategoryTitle = selectedCategory.title;
          if (this.selectedCategoryTitle === 'Other') {
            this.subcatgname = true;
            this.toolspecify = false;
            this.dynamicFields = [];
            this.addForm.get('specifications')?.setValue({});
            this.dropdownOptions = {};
            // this.addForm.get('highlights')?.setValue(null);
          } else {
            this.subcatgname = false;
          }
        }
        this.service.get({ category3_id: id }, `${API_ROUTES.Account.getSpecification}`).pipe().subscribe((res: { result: { rows: any; }; }) => {
          this.specification = res.result;
          // console.log(this.specification);
          if (this.specification?.length > 0) {
            this.toolspecify = false;
            const result = this.specification[0];
            this.dynamicFields = Object.keys(result).filter(
              key => !['id', 'category3_id', 'created_at', 'updated_at'].includes(key)
            );

            // Populate dropdown options
            this.dynamicFields.forEach(field => {
              if (!this.dropdownOptions[field]) {
                this.dropdownOptions[field] = []; // Initialize if undefined
              }
              this.dropdownOptions[field] = [
                ...new Set(
                  this.specification
                    .map((item: { [key: string]: any }) => item[field]?.toString())
                    .filter((value: string | undefined) => value !== undefined && value !== '') // Exclude undefined or blank values
                ),
              ] as string[]; // Cast to string[] to satisfy type safety
            });

            // Initialize selected values
            this.selectedValues = this.dynamicFields.reduce((acc: { [key: string]: string }, field) => {
              // If selectedData exists and has a value for the field, use it
              if (selectedData && selectedData[field]) {
                acc[field] = selectedData[field];
              } else {
                // Otherwise, initialize as empty
                acc[field] = '';
              }
              return acc;
            }, {});
            if (this.selectedValues['is_atc'] !== 'Yes') {
              delete this.selectedValues['atc'];
            }

            // Patch values to the form
            this.addForm.get('specifications')?.patchValue(this.selectedValues);
            this.addForm.get('highlights')?.removeValidators([Validators.required]);
            this.addForm.get('highlights')?.updateValueAndValidity();
          } else if (this.selectedCategoryTitle != 'Other' && (this.specification?.length == 0)) {
            this.toolspecify = true;
            this.addForm.get('specifications')?.patchValue({});
            this.addForm.get('highlights')?.setValidators([Validators.required]);
            this.addForm.get('highlights')?.updateValueAndValidity();
          } else {
            this.toolspecify = false;
            this.addForm.get('highlights')?.removeValidators([Validators.required]);
            this.addForm.get('highlights')?.updateValueAndValidity();
          }

        }, (err: any) => {
          this.category3 = [];
        });
      })
    );
  }
  transformLabel(field: string): string {
    return field
      .split('_') // Split the field on underscores
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' '); // Join the words with a space
  }
  onSelectionChange(field: string, event: Event) {
    const target = event.target as HTMLSelectElement;
    const value = target.value;

    // Update the selected values
    this.selectedValues[field] = value;

    // Update specifications object in the form
    const specifications = this.addForm.get('specifications')?.value || {};
    specifications[field] = value;

    // **Remove 'atc_key' when 'is_atc' is No**
    if (field == 'is_atc' && value !== 'Yes') {
      delete specifications['atc']; // Remove from form data
      delete this.selectedValues['atc']; // Remove from UI selected values
    }

    this.addForm.patchValue({ specifications });
    console.log('Updated Specifications:', specifications);
  }

  // onSelectionChange(field: string, event: Event) {
  //   const target = event.target as HTMLSelectElement;
  //   const value = target.value;

  //   // Update the specifications object directly with the selected value
  //   const specifications = this.addForm.get('specifications')?.value || {};
  //   specifications[field] = value;

  //   // Update the form value
  //   this.addForm.patchValue({ specifications });
  //   // console.log('Updated Specifications:', specifications);
  // }


  alldropdown: any;
  getDropdowns() {
    this.service.post('', `${API_ROUTES.Account.getAllDropdowns}`, {}).pipe().subscribe((res: { result: any; }) => {
      this.alldropdown = res.result;
    })
  }

  submitted = false;

  discard() {
    window.scrollTo(0, 0);
    if (this.productId) {
      this.getData();
    } else {
      this.addForm.reset();
      this.dynamicFields = [];
    }
  }
  handleKeyPress(event: KeyboardEvent): boolean {
    return this.service.onKeyPressNumericOnly(event);
  }
  offer: boolean = false;
  onToggleChange(event: Event, controlName: string): void {
    const checkbox = event.target as HTMLInputElement;
    const control = this.addForm.get(controlName);
    if (control) {
      if (controlName == 'is_featured' || controlName == 'is_sold') {
        control.setValue(checkbox.checked ? true : false);
      } else {
        control.setValue(checkbox.checked ? 'yes' : 'no');
      }
      this.updateWarrantyPeriodValidator();
      if (this.addForm.get('offer_applicable')?.value == 'yes') {
        this.offer = true;
        this.addForm.get('offer_details')?.setValidators([Validators.required]);
        this.addForm.get('offer_details')?.updateValueAndValidity();
      } else {
        this.addForm.get('offer_details')?.removeValidators([Validators.required]);
        this.addForm.get('offer_details')?.updateValueAndValidity();
        this.addForm.get('offer_details')?.setValue(null);
        this.offer = false;
      }
    } else {
      console.error(`${controlName} not found in form`);
    }
  }
  warranty: boolean = false;
  updateWarrantyPeriodValidator(): void {
    if (this.addForm.get('warranty_available')?.value == 'yes') {
      this.warranty = true;
    } else {
      this.warranty = false;
    }
    const warrantyAvailable = this.addForm.get('warranty_available')?.value == 'yes';
    const warrantyPeriodControl = this.addForm.get('warranty_period');
    if (warrantyAvailable) {
      warrantyPeriodControl?.setValidators([Validators.required]);
    } else {
      warrantyPeriodControl?.removeValidators([Validators.required]);
      warrantyPeriodControl?.clearValidators();
    }
    warrantyPeriodControl?.updateValueAndValidity();
  }
  condition = [
    { id: 'new', title: 'New' },
    { id: 'used', title: 'Used' },
  ]

  goBack() {
    this.commonService.goBack();
  }

  viewImage(url: any) {
    this.commonService.viewImage(url);
  }

  fileUploads: any[] = [{}];

}

